<template>
  <div class="freeze" v-if="rows.length">
    <div class="freeze__head">
      <span><span class="freeze__dot"></span>{{ c.feed.sectionTitle }}</span>
      <span class="freeze__count" v-if="count !== null">{{ count24hLabel }}</span>
    </div>
    <ul class="freeze__list">
      <li v-for="row in rows" :key="row.id">
        <span class="freeze__badge">{{ c.feed.status }}</span>
        <a :href="'https://tronscan.org/#/address/' + row.address" target="_blank" rel="noopener">{{ short(row.address) }}</a>
        <span class="freeze__time">{{ ago(row.time) }}</span>
      </li>
    </ul>
    <p class="freeze__source">{{ c.feed.source }}</p>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { content as c, lang } from '@/i18n'
import { fetchFeed } from '@/tron'

// 黑U检测下方：最近被 Tether 冻结的 TRON 地址（/api/feed，服务端缓存 60 分钟）
const rows = ref([])
const count = ref(null)
const short = a => a ? a.slice(0, 8) + '…' + a.slice(-6) : ''
const count24hLabel = computed(() => lang.value === 'en' ? `${count.value} in the last 24h` : `过去 24 小时 ${count.value} 个`)

function ago(t) {
  const s = Math.max(60, Math.floor((Date.now() - t) / 1000))
  const u = c.value.feed.ago
  if (s < 3600) return Math.floor(s / 60) + u.m
  if (s < 86400) return Math.floor(s / 3600) + u.h
  return Math.floor(s / 86400) + u.d
}

onMounted(async () => {
  try {
    const data = await fetchFeed()
    rows.value = data.items.slice(0, 6)
    count.value = data.count24h ?? null
  } catch (e) { /* 拿不到就不显示这一块 */ }
})
</script>

<style scoped>
.freeze { max-width: 820px; margin: 40px auto 0; border: 1px solid var(--ink-line); background: rgba(255,255,255,.02); }
.freeze__head { display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 14px 20px; border-bottom: 1px solid var(--ink-line); font-family: var(--font-mono); font-size: 11px; letter-spacing: .16em; color: var(--ink-text); }
.freeze__dot { display: inline-block; width: 7px; height: 7px; border-radius: 50%; background: var(--danger); margin-right: 10px; }
.freeze__count { color: var(--ink-dim); }
.freeze__list { display: grid; grid-template-columns: 1fr 1fr; }
.freeze__list li { display: flex; align-items: center; gap: 12px; padding: 12px 20px; border-bottom: 1px solid rgba(255,255,255,.04); }
.freeze__list li:nth-child(odd) { border-right: 1px solid rgba(255,255,255,.04); }
.freeze__badge { font-family: var(--font-mono); font-size: 10px; color: var(--danger); border: 1px solid rgba(255,77,61,.45); padding: 2px 6px; white-space: nowrap; }
.freeze__list a { font-family: var(--font-mono); font-size: 13px; color: var(--ink-text); flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; }
.freeze__list a:hover { color: var(--accent); }
.freeze__time { font-family: var(--font-mono); font-size: 11px; color: var(--ink-dim); white-space: nowrap; }
.freeze__source { padding: 10px 20px; font-size: 11px; color: var(--ink-dim); }
@media (max-width: 700px) {
  .freeze__list { grid-template-columns: 1fr; }
  .freeze__list li:nth-child(odd) { border-right: 0; }
}
</style>
